import React from 'react';

const UserMenu: React.FC = () => {
  return null; // Empty component since we're removing the GitHub link
};

export default UserMenu;